import axios from 'axios';
import qs from 'qs';

import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import config from '@/config/config.ts';

export const axiosClient = axios.create({
  baseURL: config.VITE_APP_API_URL,
  withCredentials: true,
  paramsSerializer(params) {
    return qs.stringify(params, {
      arrayFormat: 'repeat',
    });
  },
});

keycloakAuthenticationHandler.secureAxiosClient(axiosClient);
